import { useTranslation } from 'react-i18next'

import { Card, Badge } from 'ui'
import { DateTime } from 'components/UI'
import AttachmentsList from 'Employee/schedule/AttachmentsList'
import { TimeOffInfo } from './TimeOffInfo'
import { isBefore, parseISO, subDays } from 'date-fns'
import { FC } from 'react'

const TimeOff: FC<{ timeOff: MData.TimeOff }> = ({ timeOff }) => {
  const { t } = useTranslation('legacy')
  const { _id, start, end, files = [], vacationTypeId } = timeOff

  const isBeforeToday = isBefore(parseISO(start), subDays(new Date(), 1))
  const timeOffOpacity = isBeforeToday ? 0.6 : 1

  return (
    <Card id={`my_schedule_timeOff_${_id}`} className="mb-1 border-complimentary" key={_id} style={{ opacity: timeOffOpacity }}>
      <Card.Body className="p-2 d-flex align-items-center position-relative">
        <div className="d-flex flex-column align-items-start">
          <a href={`/my/timeoff/${_id}`}>
            <Badge className="p-2" variant="complimentary">
              {t('employee.mySchedule.TIME_OFF')}
            </Badge>
          </a>
          <h5 className="mt-2">
            <DateTime date={[start, end]} outFormat="time" range noParantheses />
          </h5>
          <TimeOffInfo _id={_id} vacationTypeId={vacationTypeId} />
          <AttachmentsList files={files} />
        </div>
      </Card.Body>
    </Card>
  )
}

export default TimeOff
